import { render, staticRenderFns } from "./Abstract.vue?vue&type=template&id=5e552f52&scoped=true"
import script from "./Abstract.vue?vue&type=script&lang=ts"
export * from "./Abstract.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Abstract.vue?vue&type=style&index=0&id=5e552f52&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5e552f52",
  "60bcedca"
  
)

export default component.exports